export default "__VITE_ASSET__euUQJU4z__"